import { Dialog, Transition } from '@headlessui/react'
import { useRouter } from 'next/router'
import { Fragment } from 'react'
import { useToasts } from 'react-toast-notifications'

import { Offerings } from '@infura/packages.api'
import { getUserCreditAddonQuantity, getUserThroughputAddonEnabled } from '@infura/packages.common/user'
import { ServiceTier, V1Service } from '@infura/packages.uks'

import { Checkout } from 'components/checkout/Checkout'

import { BILLING_PLAN_ROUTE } from 'lib/constants'

interface Props {
  isCheckoutModalVisible: boolean
  toggleCheckoutModalVisible: () => void
  selectedPlan: ServiceTier
  servicePlan?: V1Service
  offerings: Offerings
}

export const UpgradePlanCheckoutModal = ({
  isCheckoutModalVisible,
  offerings,
  selectedPlan,
  servicePlan,
  toggleCheckoutModalVisible
}: Props) => {
  const Router = useRouter()
  const { addToast } = useToasts()

  return (
    <Transition.Root as={Fragment} show={isCheckoutModalVisible}>
      <Dialog
        as='div'
        className='fixed inset-0 z-50 overflow-y-auto'
        onClose={() => {
          toggleCheckoutModalVisible()
        }}
      >
        <div className='flex min-h-screen flex-col items-stretch justify-center px-2 text-center md:block md:pb-20 md:pt-4'>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Dialog.Overlay
              className='fixed inset-0 bg-black bg-opacity-75 transition-opacity'
              onClick={() => {
                toggleCheckoutModalVisible()
              }}
            />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span aria-hidden='true' className='hidden md:inline-block md:h-screen md:align-middle'>
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            enterTo='opacity-100 translate-y-0 sm:scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
          >
            <Dialog.Panel className='m-2 transform rounded-md shadow-lg transition-all sm:m-0 md:inline-block md:w-full md:max-w-xl md:align-middle'>
              <Checkout
                checkoutCloseCallback={toggleCheckoutModalVisible}
                currentRequestPacksQuantity={getUserCreditAddonQuantity(servicePlan)}
                currentThroughputAddonEnabled={getUserThroughputAddonEnabled(servicePlan)}
                offerings={offerings}
                onSubscriptionUpdated={async () => {
                  await Router.push({ pathname: BILLING_PLAN_ROUTE })
                  addToast('Upgrade successful', {
                    appearance: 'success',
                    autoDismiss: true
                  })
                }}
                requestPacksQuantity={getUserCreditAddonQuantity(servicePlan)}
                selectedPlan={selectedPlan}
                servicePlan={servicePlan}
                throughputAddonEnabled={getUserThroughputAddonEnabled(servicePlan)}
              />
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
